import { Pipe, PipeTransform } from '@angular/core';
import { CSPSubscriptions, GetCSPSubscriptionActions, GetCSPSubscription } from '../../models/csp.model';

@Pipe({
  name: 'cspFilter'
})

export class CspFilterPipe implements PipeTransform {
  transform(value: CSPSubscriptions[], filterString: string, filterList: string[], subscriptionActions: GetCSPSubscriptionActions[]): any {
    value = value.filter(subscription => 
    (
      subscription.baseSubscription.out_stock_code.toLowerCase().includes(filterString.toLowerCase()) ||
      subscription.baseSubscription.out_subscription_id.toLowerCase().includes(filterString.toLowerCase()) ||
      subscription.baseSubscription.out_mpnid.toLowerCase().includes(filterString.toLowerCase()) ||
      subscription.baseSubscription.out_price_number.toString().includes(filterString) ||
      subscription.baseSubscription.out_amount.toString().includes(filterString) ||
      subscription.baseSubscription.out_status_desc.toLowerCase().includes(filterString.toLowerCase()) || 
      subscription.baseSubscription.out_stk_description.toLowerCase().includes(filterString.toLowerCase()) ||
      subscription.baseSubscription.out_next_billing_date.toLowerCase().includes(filterString.toLowerCase()) ||
      subscription.addOnSubscription.filter(addon => addon.out_stock_code.toLowerCase().includes(filterString.toLowerCase()) ||
        addon.out_stk_description.toLowerCase().includes(filterString.toLowerCase())).length
    ) && 
    this.FilterStatus(subscription, filterList, subscriptionActions));
    return value;
  }

  private FilterStatus(subscription: CSPSubscriptions, filterList: string[], subscriptionActions: GetCSPSubscriptionActions[]): boolean{
    let flag = false;
    if(!filterList.length){
      flag = true;
      return flag;
    }else{
      if(filterList.includes("active")){
        if((this.getPendingMessage(subscription.baseSubscription, subscriptionActions).out_message.toLowerCase().includes("active") || subscription.baseSubscription.out_status_desc.toLowerCase().includes("active") || subscription.addOnSubscription.filter(addon => addon.out_stock_code.toLowerCase().includes("active") || addon.out_stk_description.toLowerCase().includes("active") || this.getPendingMessage(addon, subscriptionActions).out_message.toLowerCase().includes("active")).length) && !this.getPendingMessage(subscription.baseSubscription, subscriptionActions).out_message.toLowerCase().includes("pending") && !this.getPendingMessage(subscription.baseSubscription, subscriptionActions).out_message.toLowerCase().includes("failed") && !this.getPendingMessage(subscription.baseSubscription, subscriptionActions).out_message.toLowerCase().includes("error")){
          flag = true;
          return flag;
        }
      }
      if(filterList.includes("suspend")){
        if((this.getPendingMessage(subscription.baseSubscription, subscriptionActions).out_message.toLowerCase().includes("suspend") || subscription.baseSubscription.out_status_desc.toLowerCase().includes("suspend") || subscription.addOnSubscription.filter(addon => addon.out_stock_code.toLowerCase().includes("suspend") || addon.out_stk_description.toLowerCase().includes("suspend") || this.getPendingMessage(addon, subscriptionActions).out_message.toLowerCase().includes("suspend")).length) && !this.getPendingMessage(subscription.baseSubscription, subscriptionActions).out_message.toLowerCase().includes("pending") && !this.getPendingMessage(subscription.baseSubscription, subscriptionActions).out_message.toLowerCase().includes("failed") && !this.getPendingMessage(subscription.baseSubscription, subscriptionActions).out_message.toLowerCase().includes("error")){
          flag = true;
          return flag;
        }
      }
      if(filterList.includes("pending")){
        filterList.forEach((item: string) => {
          if(this.getPendingMessage(subscription.baseSubscription, subscriptionActions).out_message.toLowerCase().includes(item.toLowerCase()) || subscription.baseSubscription.out_status_desc.toLowerCase().includes(item.toLowerCase()) || subscription.addOnSubscription.filter(addon => addon.out_stock_code.toLowerCase().includes(item.toLowerCase()) || addon.out_stk_description.toLowerCase().includes(item.toLowerCase()) || this.getPendingMessage(addon, subscriptionActions).out_message.toLowerCase().includes(item.toLowerCase())).length){
            flag = true;
            return;
          }
        });
      }
      return flag;
    }
  }

  private getPendingMessage(subscription: GetCSPSubscription, subscriptionActions: GetCSPSubscriptionActions[]): GetCSPSubscriptionActions {
    let pendingChange = {} as GetCSPSubscriptionActions;
    pendingChange.out_message = "";
    pendingChange.changeAmount = 0;
    pendingChange.hasChange = false;
    subscriptionActions.forEach(subscriptionAction => {
      if (!subscriptionAction.out_error_message) {
        if (subscription.out_subscription_id == subscriptionAction.out_subscription_id) {
          pendingChange.out_status_desc = subscriptionAction.out_status_desc;
          switch (subscriptionAction.out_key) {
            case "CREATE": { pendingChange.out_message += "Pending Order Creation "; break; }
            case "QTY": { pendingChange.out_message += "Pending Qty Change to " + subscriptionAction.out_value + " "; break; }
            case "MPNID": { pendingChange.out_message += "Pending MPN ID Change to " + subscriptionAction.out_value + " "; break; }
            case "REF": { pendingChange.out_message += "Pending Reference Change to " + subscriptionAction.out_value + " "; break; }
            case "SUSPEND":
              {
                pendingChange.out_message += "Pending Suspension ";
                break;
              }
            case "REACTIVATE":
              {
                pendingChange.out_message += "Pending Reactivation ";
                break;
              }
          }
          pendingChange.changeAmount++;
        }
      } else {
        if (subscription.out_subscription_id == subscriptionAction.out_subscription_id) {
          pendingChange.out_status_desc = subscriptionAction.out_status_desc;
          pendingChange.out_message += subscriptionAction.out_error_message + " ";
          pendingChange.changeAmount++;
        }
      }
    });
    return pendingChange;
  }
}
